<template lang="pug">
div.box
    v-server-table(
        :url="datatableUrl",
        :name="tableName",
        ref="datatable",
        :columns="columns",
        :options="options"
    )
        template(slot="beforeTable")
            datatable-loader(:name="tableName")

    receipt(ref="receipt")
</template>

<script>
import { mapState } from 'vuex';
import receiptMixin from '../../mixins/receipt';

export default {
    mixins: [receiptMixin],

    data() {
        var columns = [
            'returned_at',
            'settled_date',
            'receipt_number',
            'returner',
            'reason',
            'till_closure',
            'till_summary',
            'cashier',
            'payment_type',
            'name',
            'quantity',
            'total_amount',
            'outlet_name',
        ];

        return {
            tableName: 'RETURNED_ITEMS',
            columns,
            options: {
                headings: {
                    receipt_number: 'Receipt No.',
                    settled_date: 'Receipt Date',
                    returner: 'Returned by',
                    returned_at: 'Returned At',
                    outlet_name: this.trans('general.outlet'),
                    total_amount: 'Total Amount (RM)',
                    payment_type: 'Payment Type',
                    till_closure: 'Till Closure No.',
                    till_summary: 'Till Summary No.',
                    name: 'Product Name',
                },
                useReportFilter: true,
                customFilters: ['outlet_id', 'since', 'until', 'filters'],
                texts: {
                    title: 'Returned Items',
                    description: 'Shows list of returned items',
                },
                columnsClasses: {
                    total_amount: 'text-right',
                    quantity: 'text-right',
                },
                pdf_url: Laroute.route(
                    'franchise.report.voidedsales.voided_orders_export',
                    { type: 'PDF' },
                ),
                csv_url: Laroute.route(
                    'franchise.report.voidedsales.voided_orders_export',
                    { type: 'CSV' },
                ),
                xls_url: Laroute.route(
                    'franchise.report.voidedsales.voided_orders_export',
                    { type: 'XLSX' },
                ),
                templates: {
                    receipt_number: (h, row, col) => {
                        return this.receiptNumberFormat(row);
                    },

                    returned_at: (h, row, col) => {
                        return this.receiptDateFormat(row.returned_at);
                    },
                    reason(h, row) {
                        return require('./void-remarks')(h, row);
                    },
                    settled_date: (h, row) => {
                        return this.receiptDateFormat(row.settled_date);
                    },
                    outlet_name: (h, row) => {
                        return row.outlet_name.substring(0, 20);
                    },
                },
                orderBy: {
                    ascending: false,
                    column: 'returned_at',
                },
            },
        };
    },

    computed: {
        ...mapState('tillFilter', ['filters']),

        datatableUrl() {
            return Laroute.route('franchise.report.voidedsales.voided_orders');
        },

        getActiveOutlet() {
            return this.$store.getters.activeOutlet;
        },
    },

    watch: {
        filters: function(to, from) {
            if (to === from) return;

            this.setFilter();
        },

        getActiveOutlet() {
            this.setColumnDisplay();
        },
    },

    mounted() {
        this.setColumnDisplay();
    },

    created() {
        this.removeLimitState();
        window.addEventListener('beforeunload', this.removeLimitState);
    },

    methods: {
        showReceipt(transaction_id) {
            this.$refs.receipt.$emit('show-receipt', transaction_id);
        },

        setFilter() {
            this.$store.commit(`${this.tableName}/SET_CUSTOM_FILTER`, {
                filter: 'filters',
                value: this.filters,
            });
        },

        removeLimitState() {
            let query = JSON.parse(
                localStorage.getItem(`vuetables_${this.tableName}`),
            );

            if (!_.isNull(query) && !_.isUndefined(query.perPage)) {
                query.perPage = 20;

                localStorage.setItem(
                    `vuetables_${this.tableName}`,
                    JSON.stringify(query),
                );
            }
        },

        setColumnDisplay() {
            if (this.getActiveOutlet != 0) {
                this.$refs.datatable.userControlsColumns = true;
                this.$refs.datatable.userColumnsDisplay = [
                    'returned_at',
                    'settled_date',
                    'receipt_number',
                    'returner',
                    'reason',
                    'till_closure',
                    'till_summary',
                    'name',
                    'quantity',
                    'cashier',
                    'payment_type',
                    'total_amount',
                ];
            } else {
                this.$refs.datatable.userColumnsDisplay = this.columns;
            }
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/voided/voided-orders.vue